import { render, staticRenderFns } from "./CweVulnerability.vue?vue&type=template&id=5ce3d434&"
import script from "./CweVulnerability.vue?vue&type=script&lang=js&"
export * from "./CweVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports